export const GET_TWILIO_GET_FILE_STATUS = "GET_TWILIO_GET_FILE_STATUS";
export const GET_TWILIO_GET_FILE_STATUS_SUCCESS =
  "GET_TWILIO_GET_FILE_STATUS_SUCCESS";
export const GET_TWILIO_GET_FILE_STATUS_FAILURE =
  "GET_TWILIO_GET_FILE_STATUS_FAILURE";

export const GET_TWILIO_REQUEST_OTP = "GET_TWILIO_REQUEST_OTP";
export const GET_TWILIO_REQUEST_OTP_SUCCESS = "GET_TWILIO_REQUEST_OTP_SUCCESS";
export const GET_TWILIO_REQUEST_OTP_FAILURE = "GET_TWILIO_REQUEST_OTP_FAILURE";

export const GET_TWILIO_GET_FILE = "GET_TWILIO_GET_FILE";
export const GET_TWILIO_GET_FILE_SUCCESS = "GET_TWILIO_GET_FILE_SUCCESS";
export const GET_TWILIO_GET_FILE_FAILURE = "GET_TWILIO_GET_FILE_FAILURE";

export const getTwilioGetFileStatus = (fileName) => ({
  type: "GET_TWILIO_GET_FILE_STATUS",
  fileName,
});

export const getTwilioGetFileStatusSuccess = (data) => ({
  type: "GET_TWILIO_GET_FILE_STATUS_SUCCESS",
  data,
});

export const getTwilioGetFileStatusFailure = (message) => ({
  type: "GET_TWILIO_GET_FILE_STATUS_FAILURE",
  message,
});

//twilio request otp
export const getTwilioRequestOTP = (fileName) => ({
  type: "GET_TWILIO_REQUEST_OTP",
  fileName,
});

export const getTwilioRequestOTPSuccess = (data) => ({
  type: "GET_TWILIO_REQUEST_OTP_SUCCESS",
  data,
});

export const getTwilioRequestOTPFailure = (message) => ({
  type: "GET_TWILIO_REQUEST_OTP_FAILURE",
  message,
});

//get twilio get file
export const getTwilioGetFile = (fileName, otpCode) => ({
  type: "GET_TWILIO_GET_FILE",
  fileName,
  otpCode,
});

export const getTwilioGetFileSuccess = (data) => ({
  type: "GET_TWILIO_GET_FILE_SUCCESS",
  data,
});

export const getTwilioGetFileFailure = (message) => ({
  type: "GET_TWILIO_GET_FILE_FAILURE",
  message,
});
